import axios from '@/lib/AxApi';

export default {
  getPatientsGallery(params, cb)
  {
    axios.get('/rest/PatientsGallery/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  savePatientsGallery(params, cb)
  {
    if(typeof params.id != 'undefined' && params.id != '')
    {
      axios.post('/rest/PatientsGallery/updateRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
    else
    {
      axios.post('/rest/PatientsGallery/insertRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
  },
  deletePatientsGallery(params, cb)
  {
    axios.post('/rest/PatientsGallery/deleteRow', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  rotateImage(params, cb)
  {
    axios.post('/rest/PatientsGallery/rotateImage', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/patientsgallery.js